import * as Scrivito from "scrivito";
import { Collapse } from "reactstrap";

function MobileSearchField({ searchResultsPage, show }) {
  if (!searchResultsPage) {
    return null;
  }

  return (
    <Collapse isOpen={show}>
      <form
        action={Scrivito.urlFor(searchResultsPage)}
        className="w-100 pe-3"
        method="GET"
      >
        <input autoFocus name="q" type="text" className="search-input-mobile" />
      </form>
    </Collapse>
  );
}
export default Scrivito.connect(MobileSearchField);
